import { NavLink } from "react-router-dom";
import { 
  LayoutDashboard, ShieldCheck, Users, UserCog, Route, 
  Settings, Layers, Folder, Wallet, Mail, Car,
  Ticket, History, MessageSquare, BellRing 
} from "lucide-react";
import Logo from "../components/common/Logo";
import "./layout.css";

const navSections = [
  {
    title: "Tableau de Bord",
    items: [{ label: "Vue d'ensemble", path: "/", icon: LayoutDashboard }],
  },
  {
    title: "Opérations",
    items: [
      { label: "Commandes", path: "/rides", icon: Route },
      { label: "Vehicules clients", path: "/cars", icon: Car },
    ],
  },
  {
    title: "Finance",
    items: [
      { label: "Portefeuilles", path: "/wallet", icon: Wallet },
      { label: "Historique Flux", path: "/transactions", icon: History },
    ],
  },
  {
    title: "Utilisateurs",
    items: [
      { label: "Chauffeurs", path: "/drivers", icon: UserCog },
      { label: "Clients", path: "/clients", icon: Users },
      { label: "Équipe Admin", path: "/admins", icon: ShieldCheck },
    ],
  },
  
  {
    title: "Marketing & Support",
    items: [
      { label: "Codes Promos", path: "/promotions", icon: Ticket },
      { label: "Notifications ", path: "/newsletter", icon: BellRing },
      { label: "Plaintes ", path: "/plaintes", icon: MessageSquare },
    ],
  },
  {
    title: "Configuration",
    items: [
      { label: "Types de Documents", path: "/documents", icon: Folder },
      { label: "Types de Commandes", path: "/order-types", icon: Layers },
      { label: "Paramètres", path: "/settings", icon: Settings },
    ],
  },
];

export default function Sidebar({ open, onClose }) {
  return (
    <>
    
      <div
        className={`sidebarOverlay ${open ? "show" : ""}`}
        onClick={onClose}
      />

      <aside className={`sidebar ${open ? "open" : ""}`}>
        <div className="brand">
          <Logo size={80} radius={18} />
        </div>

        <nav className="nav">
          {navSections.map((section) => (
            <div key={section.title}>
              <div className="sidebarSectionTitle">
                {section.title}
              </div>

              {section.items.map((it) => {
                const Icon = it.icon;
                return (
                  <NavLink
                    key={it.path}
                    to={it.path}
                    end={it.path === "/"}
                    onClick={onClose}   
                    className={({ isActive }) =>
                      `navItem ${isActive ? "active" : ""}`
                    }
                  >
                    <Icon size={18} />
                    <span>{it.label}</span>
                  </NavLink>
                );
              })}
            </div>
          ))}
        </nav>
      </aside>
    </>
  );
}